
import { colors } from '~/helpers/colors'
export default {
  name: 'FilterListItem',
  props: {
    filterLabel: {
      type: String,
      required: true,
    },
    facetValues: {
      type: Array,
      default: () => [],
    },
    facetData: {
      type: Object,
      default: () => ({}),
    },
    wording: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      listItemToggled: false,
      filterActive: false,
    }
  },
  computed: {
    activeFacetValues() {
      // COLOR SWATCHES
      if (this.facetData.field === 'ss_normalize_color') {
        return this.facetValues
          .filter((item) => item.active)
          .map((item) => this.colorSwatch(item.value))
        // PRICES
      } else if (this.facetData.field === 'ss_final_price') {
        return this.facetValues
          .filter((item) => item.active)
          .map(
            (item) => `$${item.low === '*' ? '0' : item.low} - $${item.high}`
          )
      } else {
        return this.facetValues
          .filter((item) => item.active)
          .map((item) => item.value)
      }
    },
  },
  methods: {
    colorSwatch(colorCode) {
      return colors[colorCode].EN
    },
  },
}
